module.exports = "<div class=\"report-card\"><label translate=\"{{$ctrl.title}}\"></label><h2><span ng-bind=\"$ctrl.value\"></span></h2></div>";